import { render, staticRenderFns } from "./base_role.vue?vue&type=template&id=37c81a3c&scoped=true&"
import script from "./base_role.vue?vue&type=script&lang=js&"
export * from "./base_role.vue?vue&type=script&lang=js&"
import style0 from "./base_role.vue?vue&type=style&index=0&id=37c81a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c81a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c81a3c')) {
      api.createRecord('37c81a3c', component.options)
    } else {
      api.reload('37c81a3c', component.options)
    }
    module.hot.accept("./base_role.vue?vue&type=template&id=37c81a3c&scoped=true&", function () {
      api.rerender('37c81a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/roles/list/base_role.vue"
export default component.exports